import {useState} from "react";
import {Context} from "./component/Context";
import SubmitMetaData from "./component/SubmitMetaData";
import SubmitFile from "./component/SubmitFile";
import "./component/Style.css"
import {SubmitEdited} from "./component/SubmitEdited";
import {QuestionManageComponent} from "./component/QuestionManageComponent";
import {Translator, UploadFileType} from "../component/ForTrans";

export default function CreateTrans(){
    const [file, setFile] = useState(null)
    const [original, setOriginal] = useState("")
    const [testTranslator, setTestTranslator] = useState([Translator[0]])
    const [translate, setTranslate] = useState("")
    const [answer, setAnswer] = useState("")
    const [selectedTranslate,setSelectedTranslate] = useState("")
    const [fileType, setFileType] = useState(UploadFileType[0].value)
    const [submitVal, setSubmitVal] = useState(false)
    const [modify, setModify] = useState(false)
    const [meta, setMeta] = useState({
        source: "ko",
        target: "en",
    })
    const [metaData, setMetaData] = useState({
        translator:[Translator[0]],
        max:0,
        pass:0,
        checkStart:0,
        checkEnd:0,
        testOverview:"",
        submitterMemo:"",
    })


    return(
        <div id={"element-style"}>
            <Context.Provider value={{file, setFile, metaData, setMetaData, meta, setMeta, fileType, setFileType,setSubmitVal,modify, setModify,
                original, setOriginal, answer, setAnswer, testTranslator, setTestTranslator, translate, setTranslate,setSelectedTranslate,selectedTranslate}}>
                <SubmitMetaData/>
                {!modify&& <SubmitFile/>}
                {(submitVal && selectedTranslate && !modify) && <QuestionManageComponent original={original} translate={translate}/>}
                <SubmitEdited/>
            </Context.Provider>
        </div>
    )
}